import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TunnelPageComponent } from './tunnel-page.component';
import { TunnelHeaderComponent } from './tunnel-header/tunnel-header.component';
import { FooterModule } from '../shared/footer/footer.module';
import { PrimeNGModule } from '../shared/prime-ng.module';
import { FfsBannerModule } from '../shared/ffs-banner/ffs-banner.module';
import { LoaderModule } from '../shared/loader/loader.module';



@NgModule({
  declarations: [
    TunnelPageComponent,
    TunnelHeaderComponent,
  ],
  imports: [
    CommonModule,
    PrimeNGModule,
    FooterModule,
    FfsBannerModule,
    LoaderModule
  ],
  exports: [
    TunnelPageComponent,
    TunnelHeaderComponent,
  ]
})
export class TunnelPageModule { }
